import { DistractionChart } from "@components/atoms/DistractionChart"
import { defineBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Distraction chart",
  category: "common",
  icon: "car",
  tags: ["root"],
  editMode: "preview",
  conditions: {
    postTypes: ["page", "post"],
  },
}

export default defineBlock("rsrh/distraction-chart", (props) => {
  return (
    <div className="grid-auto gap-6 py-6">
      <div className="col-span-12 md:col-span-10 lg:col-span-8 md:col-start-2 lg:col-start-3 flex flex-col items-start gap-4">
        <DistractionChart />
      </div>
    </div>
  )
})
